import { Blocks, Elements, generateId } from "@yoopta/editor";

export const GameTitleCommands = {
  buildGameTitleElements: (editor, options = {}) => {
    const gameTitleProps = { ...options.props, nodeType: "void", readOnly: true };
    return { id: generateId(), type: "gameTitle", children: [{ text: "" }], props: gameTitleProps };
  },
  insertGameTitle: (editor, options = {}) => {
    const { at, focus, props } = options;
    const gameTitle = GameTitleCommands.buildGameTitleElements(editor, { props });
    const block = Blocks.buildBlockData({ value: [gameTitle], type: "GameTitle", meta: { align: "left", depth: 0 } });

    Blocks.insertBlock(editor, block.type, {
      focus,
      at,
      blockData: block,
    });
  },
  deleteGameTitle: (editor, blockId) => {
    Blocks.deleteBlock(editor, { blockId });
  },
  updateGameTitle: (editor, blockId, props) => {
    Elements.updateElement(editor, blockId, { props });
  },
};
